import { gql, useQuery } from "@apollo/client";
import { useState } from "react";
import { decrypt } from "./encryption";

export interface ICoupon {
  coupon_id: string;
  product_id: string;
  end_time: string;
  start_time: string;
  pricing_id: string;
  trial_days: number;
  price: number;
  dynamic: boolean;
}

interface IGetCouponListRetVal {
  result: TCouponList;
}

type TCouponList = {
  campaigns: ICoupon[];
};

export const GET_COUPONS_LIST = gql`
  query getCouponList($product_id: ID!) {
    result: getCouponList(product_id: $product_id) {
      campaigns {
        coupon_id
        trial_days
        price
        dynamic
      }
    }
  }
`;

type TUseGetCouponListRetVal = {
  couponList?: ICoupon[];
  loading: boolean;
};

export const useGetCouponList = (product_id: string): TUseGetCouponListRetVal => {
  const [couponList, setCouponList] = useState<ICoupon[] | undefined>(undefined);
  const { loading } = useQuery<IGetCouponListRetVal>(GET_COUPONS_LIST, {
    variables: { product_id },
    onCompleted: ({ result }) => {
      // If no campaigns, set empty array
      if (!result.campaigns || result.campaigns.length === 0) {
        setCouponList([]);
        return;
      }
      // Process each coupon
      setCouponList(
        result.campaigns.map((coupon) => {
          try {
            // Try to decrypt the coupon_id
            const decryptedId = decrypt(coupon.coupon_id).toLowerCase();
            return {
              ...coupon,
              coupon_id: decryptedId,
            };
          } catch {
            // If decryption fails, use original coupon_id
            return {
              ...coupon,
              coupon_id: coupon.coupon_id.toLowerCase(),
            };
          }
        })
      );
    },
  });

  return {
    couponList,
    loading,
  };
};
